import { Controller } from "stimulus";

// Slides the ticket detail panel in from the right edge whenever the contained
// ticket_detail turbo-frame starts loading (i.e. a ticket link targeting it was
// clicked), and back out on close (button, backdrop or Escape).
//
// The frame's fetch events bubble up to this element, so we don't need to wire
// every ticket link individually — dropping the drawer on a page is enough.
export default class extends Controller {
  static targets = ["panel", "backdrop"];
  static values = { frame: String };

  connect() {
    const frame = document.getElementById(this.frameValue);
    this.placeholder = frame ? frame.innerHTML : "";

    this.boundOpen = this.open.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);
    this.element.addEventListener("turbo:before-fetch-request", this.boundOpen);
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.boundOpen);
    document.removeEventListener("keydown", this.boundKeydown);
    document.body.classList.remove("overflow-hidden");
  }

  open() {
    this.panelTarget.classList.remove("translate-x-full");
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none");
    document.body.classList.add("overflow-hidden");
    document.addEventListener("keydown", this.boundKeydown);
  }

  close(event) {
    if (event) event.preventDefault();
    this.panelTarget.classList.add("translate-x-full");
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none");
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("keydown", this.boundKeydown);

    // Reset the frame after the slide-out so the next open shows fresh content
    // (and the empty state if the same drawer is reused).
    const frame = document.getElementById(this.frameValue);
    if (frame) {
      frame.removeAttribute("src");
      frame.innerHTML = this.placeholder;
    }
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close();
  }
}
